import React from 'react'
import { Link } from 'gatsby'

import logo from './MyInsuranceInfo.svg'
import logoWhite from './MyInsuranceInfo-white.svg'
import { useStore } from '../../hooks/useStore'

const Logo = props => {
  const { white, className, id, ...rest } = props
  const { state } = useStore()
  return (
    <Link
      id={id || `Global__Header__Logo`}
      className={className}
      css={`
        display: flex;
        align-items: center;
        width: 200px;

        ${props => props.theme.mediaQueries.sm} {
          width: 240px;
        }

        img {
          width: 100%;
          height: auto;
          display: block;
        }
      `}
      to={state.hasSessionToken ? '/dashboard/' : '/'}
    >
      <img
        src={white ? logoWhite : logo}
        alt="MyInsuranceInfo logo"
        width="207"
        height="28"
        {...rest}
      />
    </Link>
  )
}

export { Logo }
